export default __webpack_public_path__ + "static/media/cp.cea91ece.png";